module.exports = __webpack_public_path__ + "img/7.e2357e84.png";